"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("@hapi/joi"));
const Time = __importStar(require("@sellout/utils/.dist/time"));
const CustomFieldTypeEnum_1 = require("../enums/CustomFieldTypeEnum");
const DropDownEnum_1 = require("../enums/DropDownEnum");
exports.default = {
    /****************************************************************************************
     * Tickets
     ****************************************************************************************/
    ticketType(season, ticketTypeId) {
        return season.ticketTypes.find((ticketType) => ticketType._id === ticketTypeId);
    },
    activeTicketTypes(season) {
        var _a, _b;
        return (_b = (_a = season.ticketTypes) === null || _a === void 0 ? void 0 : _a.filter((ticketType) => ticketType.visible)) !== null && _b !== void 0 ? _b : [];
    },
    remainingTicketQty(season, ticketTypeId = null) {
        if (ticketTypeId) {
            let ticketType = season.ticketTypes.find((ticketType) => ticketType._id === ticketTypeId);
            if (!ticketType)
                return 0;
            else
                return ticketType.remainingQty;
        }
        else {
            return season.ticketTypes.reduce((cur, next) => {
                return cur + next.remainingQty;
            }, 0);
        }
    },
    remainingQtyByTicketTypes(season) {
        return season.ticketTypes.reduce((cur, ticketType) => {
            cur[ticketType._id] = this.remainingTicketQty(season, ticketType._id);
            return cur;
        }, {});
    },
    purchaseLimitByTicketTypes(season) {
        return season.ticketTypes.reduce((cur, ticketType) => {
            cur[ticketType._id] = ticketType.purchaseLimit;
            return cur;
        }, {});
    },
    getCurrentTierId(season, ticketTypeId) {
        const ticketType = season.ticketTypes.find((t) => t._id.toString() === ticketTypeId);
        const now = Time.now();
        const tier = ticketType.tiers.find((tier) => tier.startsAt < now && now < tier.endsAt);
        return tier._id;
    },
    /****************************************************************************************
     * Upgrades
     ****************************************************************************************/
    upgrade(season, upgradeId) {
        var _a;
        return (_a = season === null || season === void 0 ? void 0 : season.upgrades) === null || _a === void 0 ? void 0 : _a.find((upgrades) => upgrades._id === upgradeId);
    },
    /****************************************************************************************
     * Upgrade  validate
     ****************************************************************************************/
    validateUpgrade(upgrade, isPaid) {
        let upgradeSchema;
        let limit = isPaid ? "Purchase limit" : "RSVP limit";
        let used = upgrade.totalQty - upgrade.remainingQty;
        upgradeSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Upgrade name" is a required field' }),
            price: joi_1.default.number().required(),
            totalQty: joi_1.default.number()
                .custom((value, helpers) => {
                if (value > 0 && value < used) {
                    return helpers.error("totalqty.invalid");
                }
                return value;
            })
                .messages({
                "totalqty.invalid": '"Total qty." must be greater than or equal to number of upgrade sold',
            })
                .required()
                .min(1)
                .messages({
                "number.required": '"Total qty." is a required field',
                "number.min": '"Total qty." must be greater than 0',
            }),
            remainingQty: joi_1.default.number(),
            purchaseLimit: joi_1.default.number()
                .required()
                .min(1)
                .messages({
                "number.required": `"${limit}" is a required field`,
                "number.min": `"${limit}" must be greater than 0`,
                "number.base": `"${limit}" must be a number`,
            }),
            complimentary: joi_1.default.boolean().required(),
            complimentaryWith: joi_1.default.string().required(),
            complimentaryQty: joi_1.default.number().required(),
            ticketTypeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            imageUrl: joi_1.default.string().optional().allow(""),
            description: joi_1.default.string().optional().allow(""),
            visible: joi_1.default.boolean().required(),
            rollFees: joi_1.default.boolean().required(),
        })
            .unknown(true);
        return upgradeSchema.validate(upgrade);
    },
    /****************************************************************************************
     * Venue
     ****************************************************************************************/
    venueIds(season) {
        let venueIds = [season.venueId];
        season.performances.forEach((performance) => {
            venueIds = venueIds.concat(performance.venueStageId);
        });
        venueIds = [...new Set(venueIds)];
        venueIds = venueIds.filter((v) => !!v);
        return venueIds;
    },
    seatingId(season) {
        return season._id.replace("_", "SAMH");
    },
    /****************************************************************************************
     * Promotions
     ****************************************************************************************/
    promotion(season, promotionId) {
        var _a;
        return (_a = season === null || season === void 0 ? void 0 : season.promotions) === null || _a === void 0 ? void 0 : _a.find((promotions) => promotions._id === promotionId);
    },
    activePromotions(season, type = null) {
        var _a;
        const now = Time.now();
        let promotions = ((_a = season === null || season === void 0 ? void 0 : season.promotions) !== null && _a !== void 0 ? _a : [])
            // must be active
            .filter((promotion) => promotion.active)
            // must have remaining qty
            .filter((promotion) => promotion.remainingQty > 0)
            // must be in the correct time
            .filter((promotion) => promotion.startsAt < now && now < promotion.endsAt);
        // Optional type
        if (type !== null) {
            promotions = promotions.filter((promotion) => promotion.type === type);
        }
        return promotions;
    },
    //  /****************************************************************************************
    //  * Validate Publish
    //  ****************************************************************************************/
    validatePublish(season) {
        let seasonSchema;
        const posterImageUrlSchema = joi_1.default.object({
            original: joi_1.default.string().required().messages({
                "string.empty": '"Season image" is a required field',
                "any.required": '"Season image" is a required field',
            }),
            medium: joi_1.default.string().allow('', null).optional(),
            small: joi_1.default.string().allow('', null).optional(),
        })
            .unknown(true)
            .required()
            .messages({
            "any.required": '"Season image" is a required field',
            "object.base": '"Season image" is a required field', // handles case when it's not an object
        });
        seasonSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            name: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Season name" is a required field' }),
            description: joi_1.default.string().required().messages({
                "string.empty": '"Season description" is a required field',
            }),
            posterImageUrl: posterImageUrlSchema,
            venueId: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Venue" is required' }),
            ticketTypes: joi_1.default.array()
                .min(1)
                .messages({ "array.min": '"Season" must have atleast 1 ticket' }),
        })
            .unknown(true);
        return seasonSchema.validate(season);
    },
    /****************************************************************************************
     * Custom Fields
     ****************************************************************************************/
    customField(season, customFieldId) {
        var _a, _b;
        return ((_b = (_a = season === null || season === void 0 ? void 0 : season.customFields) === null || _a === void 0 ? void 0 : _a.find((customField) => customField._id === customFieldId)) !== null && _b !== void 0 ? _b : null);
    },
    activeCustomFields(season) {
        var _a, _b;
        return ((_b = (_a = season === null || season === void 0 ? void 0 : season.customFields) === null || _a === void 0 ? void 0 : _a.filter((customField) => customField.active)) !== null && _b !== void 0 ? _b : []);
    },
    /****************************************************************************************
     * Seating
     ****************************************************************************************/
    isSeated(season) {
        if (!season)
            return false;
        return Boolean(season.seatingChartKey);
    },
    /****************************************************************************************
     * Artist
     ****************************************************************************************/
    artistIds(season) {
        let artistIds = [];
        season.performances.forEach((performance) => {
            artistIds = artistIds
                .concat(performance.headliningArtistIds)
                .concat(performance.openingArtistIds);
        });
        artistIds = [...new Set(artistIds)];
        artistIds = artistIds.filter((a) => !!a);
        return artistIds;
    },
    /****************************************************************************************
     * Promotion  validate
     ****************************************************************************************/
    validatePromotion(promotion) {
        let promotionSchema;
        let used = promotion.totalQty - promotion.remainingQty;
        promotionSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            code: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Secret code" is a required field' }),
            type: joi_1.default.string().required(),
            remainingQty: joi_1.default.number(),
            totalQty: joi_1.default.number()
                .custom((value, helpers) => {
                if (value > 0 && value < used) {
                    return helpers.error("totalqty.invalid");
                }
                return value;
            })
                .messages({
                "totalqty.invalid": '"Total qty." must be greater than or equal to number of secret code sold',
            })
                .required()
                .min(1)
                .messages({
                "number.required": '"Total qty." is a required field',
                "number.min": '"Total qty." must be greater than 0',
            }),
            ticketTypeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            upgradeIds: joi_1.default.array().items(joi_1.default.string()).default([]),
            active: joi_1.default.boolean().required(),
            startsAt: joi_1.default.number().required(),
            endsAt: joi_1.default.number().required(),
            useLimit: joi_1.default.number().min(1).messages({
                "number.required": '"Use limit" is a required field',
                "number.min": 'Use limit" must be greater than 0',
                "number.base": '"Use limit" must be a number',
            }),
            discountType: joi_1.default.string(),
            discountValue: joi_1.default.number(),
        })
            .unknown(true);
        return promotionSchema.validate(promotion);
    },
    /****************************************************************************************
     * Schedule
     ****************************************************************************************/
    hasBeenAnnounced(season) {
        const { schedule: { announceAt }, } = season;
        const now = Time.now();
        return announceAt < now;
    },
    isAnnounced(season) {
        const { schedule: { announceAt, ticketsAt }, } = season;
        const now = Time.now();
        return announceAt < now && now < ticketsAt;
    },
    isOnSale(season) {
        const { schedule: { ticketsAt, ticketsEndAt }, } = season;
        const now = Time.now();
        return ticketsAt < now && now < ticketsEndAt;
    },
    isInProgress(season) {
        const { schedule: { startsAt, endsAt }, } = season;
        const now = Time.now();
        return startsAt < now && now < endsAt;
    },
    saleHasEnded(season) {
        const { schedule: { ticketsEndAt }, } = season;
        const now = Time.now();
        return ticketsEndAt < now;
    },
    isSoldOut(season) {
        return this.remainingTicketQty(season) > 0;
    },
    hasEnded(season) {
        const { schedule: { endsAt }, } = season;
        const now = Time.now();
        return endsAt < now;
    },
    isUnavailable(season) {
        if (!(season === null || season === void 0 ? void 0 : season.published))
            return true;
        if (!this.hasBeenAnnounced(season))
            return true;
        if (!this.isOnSale(season))
            return true;
        if (this.allTicketsAreLocked(season))
            return true;
        if (this.saleHasEnded(season))
            return true;
        return false;
    },
    allTicketsAreLocked(season) {
        var _a, _b;
        const ticketTypeCount = (_a = season === null || season === void 0 ? void 0 : season.ticketTypes) === null || _a === void 0 ? void 0 : _a.length;
        const promotionCodeTicketCount = [
            ...new Set((_b = season === null || season === void 0 ? void 0 : season.promotions) === null || _b === void 0 ? void 0 : _b.filter((a) => a.type === "Unlock").reduce((cur, promotion) => {
                // (this.isOnSale(season) ? promotion.type === "Unlock" : (promotion.type === "Presale" || promotion.type === "Unlock"))
                // if(2!==2)
                return [...cur, ...promotion.ticketTypeIds];
            }, [])),
        ].length;
        return ticketTypeCount === promotionCodeTicketCount;
    },
    /****************************************************************************************
     * CustomField  validate
     ****************************************************************************************/
    validateCustomField(customField) {
        let customFieldSchema;
        customFieldSchema = joi_1.default.object()
            .options({ abortEarly: false })
            .keys({
            label: joi_1.default.string()
                .required()
                .messages({ "string.empty": '"Question" is a required field' }),
            type: joi_1.default.string().required(),
            // minLength: Joi.number(),
            // maxLength: Joi.number(),
            // minValue: Joi.number(),
            // maxValue: Joi.number(),
            options: joi_1.default.array().items(joi_1.default.string()).default([]),
            required: joi_1.default.boolean().required(),
            active: joi_1.default.boolean().required(),
        })
            .unknown(true);
        return customFieldSchema.validate(customField);
    },
    customFieldsAreValid(seasonCustomFields, orderCustomFields) {
        var _a, _b;
        const activeFields = (_a = seasonCustomFields === null || seasonCustomFields === void 0 ? void 0 : seasonCustomFields.filter((seasonCustomField) => seasonCustomField.active)) !== null && _a !== void 0 ? _a : [];
        const validFields = (_b = activeFields === null || activeFields === void 0 ? void 0 : activeFields.filter((eventCustomField) => {
            const { _id, minLength, maxLength, minValue, maxValue, required } = eventCustomField;
            const orderCustomField = orderCustomFields === null || orderCustomFields === void 0 ? void 0 : orderCustomFields.find((orderCustomField) => orderCustomField.customFieldId === _id);
            // Field is not required and orderCustomField not empty
            if (!required && !orderCustomField)
                return true;
            // Field has not been filled out
            if (!orderCustomField)
                return false;
            let { value } = orderCustomField;
            if (!required &&
                (value === undefined ||
                    value === "NaN" ||
                    value === "" ||
                    value === DropDownEnum_1.DropDownEnum.Select)) {
                return true;
            }
            if ((eventCustomField === null || eventCustomField === void 0 ? void 0 : eventCustomField.type) === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Text) {
                value = value;
                if (value) {
                    if (minLength === 0 && maxLength === 0 && value.length > 0) {
                        return true;
                    }
                    else if (minLength === 0 && value.length <= maxLength) {
                        return true;
                    }
                    else if (maxLength === 0 && minLength <= value.length) {
                        return true;
                    }
                    else if (minLength <= value.length && value.length <= maxLength) {
                        return true;
                    }
                }
                return false;
            }
            else if (eventCustomField.type === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Dropdown) {
                value = value;
                if (value !== "" && value !== DropDownEnum_1.DropDownEnum.Select) {
                    return true;
                }
                return false;
            }
            else if (eventCustomField.type === CustomFieldTypeEnum_1.CustomFieldTypeEnum.Address) {
                value = value;
                if (value !== "") {
                    return true;
                }
                return false;
            }
            else {
                value = value;
                if (value) {
                    if (minValue === 0 && maxValue === 0 && value > 0) {
                        return true;
                    }
                    else if (minValue === 0 && value <= maxValue) {
                        return true;
                    }
                    else if (maxValue === 0 && minValue <= value) {
                        return true;
                    }
                    else if (minValue <= value && value <= maxValue) {
                        return true;
                    }
                }
                return false;
            }
        })) !== null && _b !== void 0 ? _b : [];
        return validFields.length === activeFields.length;
    },
    validateSeasonDates(season) {
        const schedule = season === null || season === void 0 ? void 0 : season.schedule;
        const announceAt = schedule === null || schedule === void 0 ? void 0 : schedule.announceAt;
        const ticketsAt = schedule === null || schedule === void 0 ? void 0 : schedule.ticketsAt;
        const ticketsEndAt = schedule === null || schedule === void 0 ? void 0 : schedule.ticketsEndAt;
        const startsAt = schedule === null || schedule === void 0 ? void 0 : schedule.startsAt;
        const endsAt = schedule === null || schedule === void 0 ? void 0 : schedule.endsAt;
        /* Actions */
        let message = "";
        if (announceAt > startsAt) {
            message = "Announcement Date should be less than Season Begins.";
            return message;
        }
        else if (ticketsAt < announceAt || ticketsAt > ticketsEndAt) {
            message =
                "Sales Begin should be greater than or equal to Announcement Date and less than Sales End.";
            return message;
        }
        else if (ticketsEndAt > endsAt) {
            message = "Sales End should be less than or equal to Season Ends.";
            return message;
        }
        return message;
    },
};
//# sourceMappingURL=SeasonUtil.js.map